// Файл Login.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const Login = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Очистить ошибки перед запросом

    try {
      const response = await fetch('/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ username: login, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Invalid credentials');
      }

      const data = await response.json();
      console.log('Received token:', data.access_token); // Проверяем, что токен пришел

      localStorage.setItem('token', data.access_token); // Сохранить токен
      setLogin(''); // Сбросить поля формы
      setPassword('');
      navigate('/protected'); // Переход на защищенную страницу
    } catch (err) {
      setError(err.message); // Установка сообщения об ошибке
    }
  };

  const areFieldsEmpty = () => !login || !password;

  return (
    <div
      style={{
        textAlign: 'center',
        margin: '0',
        padding: '0',
        backgroundColor: '#121212',
        color: '#ffffff',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <h1>
        Login to{' '}
        <span style={{ color: "#007BFF" }}>Pay</span>
        <span style={{ color: "#ffffff" }}>`</span>
        <span style={{ color: "#E0115F" }}>S</span>erver
      </h1>

      <form onSubmit={handleSubmit} style={{ marginTop: '30px' }}>
        <div style={{ marginBottom: '15px' }}>
          <input
            type="text"
            id="login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            placeholder="Login"
            style={{
              padding: '10px',
              width: '300px',
              borderRadius: '5px',
              border: '1px solid #333',
              backgroundColor: '#333',
              color: '#fff',
              fontSize: '16px',
            }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            style={{
              padding: '10px',
              width: '300px',
              borderRadius: '5px',
              border: '1px solid #333',
              backgroundColor: '#333',
              color: '#fff',
              fontSize: '16px',
            }}
          />
        </div>
        <button
          type="submit"
          disabled={areFieldsEmpty()}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: areFieldsEmpty() ? '#aaaaaa' : '#6200ea',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: areFieldsEmpty() ? 'not-allowed' : 'pointer',
            marginTop: '10px',
            opacity: areFieldsEmpty() ? 0.6 : 1,
          }}
        >
          Submit
        </button>
      </form>

      {error && (
        <div style={{ color: 'red', marginTop: '20px' }}>{error}</div>
      )}
    </div>
  );
};

export default Login;